<script setup>
// SiteUp (M6): lista interativa do WhatsApp.
//
// O backend (enricher de lista interativa) já extraiu
// título, descrição, itens e o rótulo do botão em content_attributes.list.
// Aqui só desenhamos — nada é parseado no front.
//
// O botão é amostra NÃO clicável: quem escolhe é o cliente, no WhatsApp.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from 'next/message/bubbles/Base.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();
const { t } = useI18n();

const list = computed(() => contentAttributes.value?.list ?? {});
const items = computed(() =>
  Array.isArray(list.value.items) ? list.value.items : []
);
</script>

<template>
  <BaseBubble class="p-3" data-bubble-name="interactive-list">
    <div class="flex flex-col gap-2 min-w-[15rem]">
      <!-- Cores por HERANÇA + opacidade (não slate fixo): ver regressão #438. -->
      <div class="flex items-center gap-1.5 opacity-80">
        <Icon icon="i-ph-list-bullets" class="size-4" />
        <span class="text-xs font-medium uppercase tracking-wide">
          {{ t('CONVERSATION.LIST.TITLE') }}
        </span>
      </div>

      <p v-if="list.title" class="text-sm font-medium m-0">
        {{ list.title }}
      </p>
      <p
        v-if="list.description"
        class="text-sm opacity-80 m-0 whitespace-pre-line"
      >
        {{ list.description }}
      </p>

      <ol class="flex flex-col m-0 p-0 list-none">
        <li
          v-for="(item, index) in items"
          :key="`${index}-${item.title}`"
          class="flex gap-2.5 py-2"
          :class="index > 0 ? 'border-t border-current/15' : ''"
        >
          <span
            class="flex items-center justify-center size-5 shrink-0 rounded-full text-xs font-medium bg-current/10 tabular-nums"
          >
            {{ index + 1 }}
          </span>
          <span class="flex flex-col min-w-0 gap-0.5">
            <span class="text-sm font-medium">{{ item.title }}</span>
            <span
              v-if="item.description"
              class="text-xs opacity-70 whitespace-pre-line"
            >
              {{ item.description }}
            </span>
          </span>
        </li>
      </ol>

      <p v-if="list.footer" class="text-xs opacity-70 m-0">
        {{ list.footer }}
      </p>

      <!-- Amostra do botão que o cliente viu — não é acionável no Chatwoot. -->
      <div
        v-if="list.button"
        class="mt-1 inline-flex self-start items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium bg-current/10 opacity-90 select-none pointer-events-none"
        aria-hidden="true"
      >
        <Icon icon="i-ph-caret-down" class="size-3.5" />
        <span>{{ list.button }}</span>
      </div>
    </div>
  </BaseBubble>
</template>
